module.exports = __webpack_public_path__ + "DS-Digital.5410cf1ee3575a3152a5.ttf";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/DS-Digital.ttf
// module id = ../../../../../src/assets/fonts/DS-Digital.ttf
// module chunks = styles